import React from 'react'

import styled from 'styled-components'

import { devices, ThumbnailsIcon } from '../../Common'
import { SimpleCarousel } from './SimpleCarousel'

export const LightBoxModal = ({ slides, showLightBox, activeImage, closeModal }) => {

    const getActiveIndex = () => {
        for (let i = 0; i < slides.length; i++) {
            if (slides[i].image === activeImage) return i
        }
    }

    return (
        <LBModal show={showLightBox}>
            <CarouselContainer>
                <SimpleCarousel slides={slides} clickSlide={getActiveIndex()} />
                <ThumbnailsIcon onClick={closeModal} />
            </CarouselContainer>
        </LBModal>
    )
}

const CarouselContainer = styled.div`
    width: 100%;
    @media ${devices.small} {
        width: 100%;
    }
`

const LBModal = styled.div`
    padding: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media ${devices.small} {
        width: 100%;
        height: 100%;
        padding: 0;
    }
`